import React from 'react'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '~/lib/ui/table'
import Pagination from './Pagination'
import { useCandidate } from './CandidateProvider'
import moment from 'moment'
import { useCandidateActivity } from './CandidateActivitySection'

const PAGE_SIZE = 50

const ActivityLog = () => {
  const { candidate } = useCandidate()
  const { candidateActivities } = useCandidateActivity()
  const [page, setPage] = React.useState(1)
  const total = candidateActivities?.length || 0

  // Paginate activities
  const paginated = React.useMemo(() => {
    if (!candidateActivities) return []
    const start = (page - 1) * PAGE_SIZE
    return candidateActivities.slice(start, start + PAGE_SIZE)
  }, [candidateActivities, page])

  return (
    <>
      <div className="mb-4">
        <span className="font-bold">Total Points:</span>{' '}
        {candidate.activityPoints}
      </div>
      <Table
        className="w-full border-separate"
        tableClass="w-full rounded-2xl border border-silver"
      >
        <ActivityHeading />
        <TableBody>
          {paginated.map((candidateActivity) => (
            <ActivityRow
              key={`candidate-activity-${candidateActivity.id}`}
              candidateActivity={candidateActivity}
            />
          ))}
        </TableBody>
      </Table>
      {total > PAGE_SIZE && (
        <Pagination
          page={page}
          pageSize={PAGE_SIZE}
          total={total}
          onPageChange={setPage}
        />
      )}
    </>
  )
}

export default ActivityLog

const ActivityRow = ({ candidateActivity, ...props }) => {
  const {
    content,
    activity_points: activityPoints,
    created_at,
  } = candidateActivity || {}
  const { activity_text: eventName } = content || {}
  return (
    <TableRow
      {...props}
      className="odd:bg-white even:bg-[#e2e2e2] even:bg-opacity-[29%]"
    >
      <TableCell>{eventName}</TableCell>
      <TableCell>{activityPoints}</TableCell>
      <TableCell>{moment(created_at).format('MMM D, YYYY h:mm A')}</TableCell>
    </TableRow>
  )
}

const ActivityHeading = () => {
  const cells = ['Event Name', 'Points', 'Date']
  return (
    <TableHeader className="h-6 bg-intoo-blue-medium">
      <TableRow className="text-lg text-white hover:bg-intoo-blue-medium">
        {cells.map((cell, index) => (
          <TableHead key={index} className="font-medium text-white">
            {cell}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
